import React, { Component } from "react"

import Modal from 'react-modal';

class SelectModal extends Component {
    constructor() {
        super()
        this.state = {
            show: false,
            search: '',
        }
    }

    search = (text, key) => {

        const { search } = this.props

        let data = {}
        if (key === 'search') {
            data = { search: text }
            this.setState({ search: text })
        }

        if (this._timeout) {
            clearTimeout(this._timeout)
        }

        this._timeout = setTimeout(() => {
            search && search(data)
        }, 1000)
    }

    brandName = (id) => {

        const { brands } = this.props
        const i = brands.findIndex(e => parseInt(e.id) === parseInt(id))

        if (i !== -1) {
            return "(" + brands[i].name + ")"
        }

        return ""
    }

    render = () => {

        const { show, search } = this.state
        const { selected, list, target, add, remove, connectionType } = this.props

        const text = target ? target : ""

        return (
            <div className="tgc-select-block">

                {
                    selected && selected.length > 0 ?
                        <div className="tgc-selected-list">
                            {
                                selected.map((item, index) =>
                                    <div key={`s-i-${index}`} className="tgc-selected-list-item">
                                        <div className="list-item-name">{item.name} {this.brandName(item.brandID)}</div>
                                        <div className="close-btn" onClick={() => remove(item)}>
                                            <img src="/pictures/minus.png" alt="minus"/>
                                        </div>
                                    </div>
                                )
                            }
                            <div className={`tgc-add-more ${selected.length > 1 ? "top" : ""}`} onClick={() => this.setState({ show: true })}>
                                <img src="/pictures/plus.png" alt="plus"/>
                            </div>
                        </div> :
                        <div className="tgc-modal-empty" onClick={() => this.setState({ show: true })}>
                            <p>Добавить {text}</p>
                        </div>
                }


                <Modal
                    isOpen={show}
                    onRequestClose={() => this.setState({ show: false })}
                    className="tgc-select-multiple-modal"
                    overlayClassName="tgc-select-multiple-overlay"
                    closeTimeoutMS={200}
                    ariaHideApp={false}
                >
                    <div className="tgc-select-multiple-modal-header">
                        <h2>Добавить {text}</h2>
                        <div onClick={() => this.setState({ show: false })} className="tgc-select-multiple-modal-close">
                            <img src="/pictures/close-white.png" alt="Close" />
                        </div>
                    </div>
                    <div className="tgc-select-multiple-modal-body">
                        {connectionType === "category" ?
                            <input className='tgc-search-input' name="input-1" type='text' value={search} onChange={event => this.search(event.target.value, 'search')} placeholder="Название" />
                            : null
                        }

                        <div className="tgc-search-list">
                            {
                                list && list.length > 0 && list.map((item, index) => {
                                    const i = selected.findIndex(e => e.id === item.id)

                                    const style = i !== -1 ? "disabled" : ""

                                    return (
                                        <div className={`tgc-search-list-item ${style}`} key={`item-${index}`} onClick={() => i === -1 && this.setState({ show: false }, () => add && add(item))}>
                                            <div className="tgc-search-list-name">{item.name} {this.brandName(item.brandID)}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {/* <div className="tgc-modal-bottom">
                            <div onClick={() => add && add()} className="tgc-select-multiple-modal-button">Добавить</div>
                        </div> */}
                    </div>
                </Modal >
            </div >
        )

    }

}

export default SelectModal